import { createReducer } from "@reduxjs/toolkit";
import type { CreationState } from "@redux/state/shared-types";
import { createUser, resetCreateUser } from "./create-user";

const initialState: CreationState = { justCreatedId: null, processing: "idle" };

export const createUserReducer = createReducer<CreationState>(initialState, builder => {
  builder.addCase(createUser.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justCreatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(createUser.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(createUser.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCreateUser, () => {
    return initialState;
  });
});
